
document.addEventListener('touchstart', () => {}, true);

import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

function startApp() {
  bootstrapApplication(AppComponent, appConfig)
    .catch(err => console.error(err));
}

if (typeof window !== 'undefined') {
  const host = window.location.hostname.toLowerCase();

  if (host === 'komudu.com') {
    const target =
      'https://www.komudu.com' +
      window.location.pathname +
      window.location.search +
      window.location.hash;

    window.location.replace(target);
  } else {
    startApp();
  }
} else {
  startApp();
}
